import React from 'react'
import PropTypes from 'prop-types'
import CardTitle from './CardTitle'

const Box = ({ children, i18nTitleId, className }) => (
  <div className={className}>
    {i18nTitleId && <CardTitle i18nTextId={i18nTitleId} />}
    <div className="br2 c-muted-1 pa5 pa6-l shadowIn-1 bg-base">{children}</div>
  </div>
)

Box.propTypes = {
  children: PropTypes.node,
  i18nTitleId: PropTypes.string,
  className: PropTypes.string,
}

export default Box
